import * as types from "./../types";

const state = {
  notifications: {}
};

const getters = {
  [types.notifications.getters.GET_NOTIFICATIONS]: state => {
    return state.notifications;
  }
};

const mutations = {
  [types.notifications.mutations.MUTATE_NOTIFICATIONS]: (state, payload) => {
    state.notifications = payload;
  },
  [types.notifications.mutations.MUTATE_ADD_NOTIFICATIONS]: (
    state,
    payload
  ) => {
    state.notifications.data.push(...payload.data);
    state.notifications.pagination = payload.pagination;
  }
};

const actions = {
  [types.notifications.actions.ACTION_NOTIFICATIONS]: ({ commit }, payload) => {
    commit(types.notifications.mutations.MUTATE_NOTIFICATIONS, payload);
  },
  [types.notifications.actions.ACTION_ADD_NOTIFICATIONS]: (
    { commit },
    payload
  ) => {
    commit(types.notifications.mutations.MUTATE_ADD_NOTIFICATIONS, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
